<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Visualizar Integrante'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>

              <!-- Nome -->
              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <c-readonly-field
                  label='Nome'
                  :value="integrante.nome"
                  align="justify"
                  ></c-readonly-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <!-- Vínculo -->
              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <c-readonly-field
                  label='Vínculo'
                  :value="integrante.vinculo"
                  align="justify"
                  ></c-readonly-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap>

                <!-- Função -->
                <v-flex xs11 sm5>
                  <c-readonly-field
                  label='Função'
                  :value="integrante.funcao ? integrante.funcao.descricao : '-'"
                  ></c-readonly-field>
                </v-flex>

                <v-spacer></v-spacer>

                <!-- Assessor -->
                <v-flex xs11 sm5>
                  <c-readonly-field
                  label='Assessor'
                  :value="formatAssessor.format(integrante.assessor,integrante.funcao.item)"
                  ></c-readonly-field>
                </v-flex>

              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap>

                <!-- Carga horária semanal -->
                <v-flex xs11 sm5>
                  <c-readonly-field
                  label='Carga horária semanal'
                  :value="integrante.cargaHoraria"
                  align="justify"
                  ></c-readonly-field>
                </v-flex>

                <v-spacer></v-spacer>
                
                <!-- Escolaridade -->
                <v-flex xs11 sm5>
                  <c-readonly-field
                  label='Escolaridade'
                  :value="integrante.titulacao ? integrante.titulacao.descricao : '-'"
                  ></c-readonly-field>
                </v-flex>

              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap>

                <!-- Data inicial -->
                <v-flex xs11 sm5>
                  <c-readonly-field
                  label="Data inicial"
                  :value="integrante.dataInicial ? dates.format(integrante.dataInicial) || '-' : '-'"
                  ></c-readonly-field>
                </v-flex>

                <v-spacer></v-spacer>
                
                <!-- Data final -->
                <v-flex xs11 sm5 v-if="this.integrante.situacao !== 'A'">
                  <c-readonly-field
                  label="Data final"
                  :value="integrante.dataFinal ? dates.format(integrante.dataFinal) || '-' : '-'"
                  ></c-readonly-field>
                </v-flex>
              </v-layout>

              <!-- Instituição que o membro da equipe representa -->
              <v-layout row wrap justify-space-between v-if="(integrante.vinculo === 'Externo' || integrante.vinculo === 'Aluno de pós-graduação')">
                <v-flex>
                  <c-readonly-field
                  label='Instituição que o membro da equipe representa'
                  :value="integrante.instituicao  || '-'"
                  align="justify"
                  ></c-readonly-field>
                </v-flex>
              </v-layout>

              <!-- Observação -->
              <v-layout row wrap justify-space-between>
                <v-flex>
                  <c-readonly-field
                  label="Observação"
                  :value="integrante.obsParticipante  || '-'"
                  align="justify"
                  ></c-readonly-field>
                </v-flex>
              </v-layout>

            </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Voltar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ReadonlyField from '@/components/c-readonly-field'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import dates from '@/utils/dates'
  import formatAssessor from '@/utils/assessor'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idParticipante'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      formatAssessor: formatAssessor,
      projeto: {},
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      listaAssessor: [
        { 'item': true, 'descricao': 'Sim' },
        { 'item': false, 'descricao': 'Não' }
      ],
      regrasCargaHoraria: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !isNaN(input) || 'A carga horária deve ser numérica',
        (input) => (input.length === 0 || Number(input) !== 0) || 'A carga horária não pode ser nula',
        (input) => (input.length === 0 || Number(input) > 0) || 'A carga horária não pode ser negativa'
      ],
      regrasInstituicao: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres'
      ],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR'])
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
      projetos.getIntegrante(this.idProjeto, this.idParticipante)
      .then(response => {
        this.integrante = response.data

        // Quando o integrante é o coordenador.
        if (response.data.funcao.item === 1) {
          this.listaFuncao.splice(0, 1) // Remove a função "Bolsista-PROEX".
          this.listaFuncao.splice(1, 3) // Remove as funções "Discente-coordenador", "Integrante" e "Subcoordenador".
        }

        // Quando o integrante não é o coordenador.
        if (response.data.funcao.item !== 1) {
          this.listaFuncao.splice(1, 1) // Remove a função "Coordenador".
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-textarea': TextArea,
      'c-readonly-field': ReadonlyField
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// visualizar-integrante.vue?7c480534